import { createRef, useRef } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

import { AccordionProvider } from "./AccordionContext"
import AccordionButton from "./AccordionButton"
import AccordionSection from "./AccordionSection"

import BlockAccordion from "./BlockAccordion"
import GridAccordion from "./GridAccordion"

const Accordion = ({
  children,
  isPrintable,
  allowMultipleOpen = false,
  openFirstByDefault = false,
  type = "block"
}) => {
  const AccordionDisplay = type === "grid" ? GridAccordion : BlockAccordion
  const refs = useRef(_.map(children, () => createRef()))

  const handleKeyDown = index => e => {
    switch (e.key) {
      case "ArrowUp":
        if (index > 0) {
          refs.current[index - 1].current.focus()
        }
        break
      case "ArrowDown":
        if (index < children.length - 1) {
          refs.current[index + 1].current.focus()
        }
        break
      default:
        break
    }
  }

  return (
    <div className="oj-accordion">
      <AccordionProvider
        allowMultipleOpen={allowMultipleOpen}
        isPrintable={isPrintable}
        openFirstByDefault={openFirstByDefault}
        handleKeyDown={handleKeyDown}
        refs={refs}
      >
        <AccordionDisplay itemsPerRow={4}>{children}</AccordionDisplay>
      </AccordionProvider>
    </div>
  )
}

Accordion.propTypes = {
  allowMultipleOpen: PropTypes.bool,
  type: PropTypes.oneOf(["block", "grid"]),
  children: PropTypes.node.isRequired,
  isPrintable: PropTypes.bool,
  openFirstByDefault: PropTypes.bool
}

Accordion.displayName = "Accordion"

Accordion.Button = AccordionButton
Accordion.Section = AccordionSection
Accordion.Provider = AccordionProvider

export default Accordion
